package org.ksdfv.thelema.phys

import kotlin.native.concurrent.ThreadLocal

@ThreadLocal
object PHYS: IPhys {
    lateinit var proxy: IPhys

    override fun world(): IPhysicsWorld = proxy.world()

    override fun destroy() = proxy.destroy()
}